module.exports = __webpack_public_path__ + "static/media/icons-alt.ce327527.svg";